import { styled } from "styled-components";
import { sizes } from "styles";

export const ClassScheduleContainer = styled.div<{ isWidthApplied: boolean }>`
  width: ${({ isWidthApplied }) =>
    isWidthApplied ? `${sizes.kelasLive.classScheduleCardWidth}` : "auto"};
  flex-shrink: 0;
  border-radius: 8px;
  background: ${({ theme }) => theme.colors.white};
  padding: 20px;
  box-shadow: 0px 0px 14px ${({ theme }) => theme.colors.transparent.white10};
  position: relative;
`;

export const ClassScheduleHeading = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["xl"]};
  color: ${({ theme }) => theme.colors.black};
`;

export const ClassScheduleSubjectBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const ClassScheduleRow = styled.div`
  display: flex;
  align-items: center;
`;

export const ClassScheduleIconWrapper = styled.div<{ bgColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background-color: ${({ bgColor }) => bgColor};
  margin-right: 8px;
`;

export const PlaceholderIconWrapper = styled.div`
  width: 24px; /* Same width as the icon */
  height: 24px; /* Keeps alignment consistent */
  margin-right: 8px;
`;

export const ClassScheduleIcon = styled.img`
  width: 18px;
  height: 18px;
`;

export const ClassScheduleSubject = styled.div<{ textColor: string }>`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-weight: bold;
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  color: ${({ textColor }) => textColor};
  margin: 0;
`;

export const ClassScheduleTime = styled.p`
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  color: ${({ theme }) => theme.colors.neutral[600]};
  margin: 4px 0 0;
`;
